import {AbstractDTO} from "@signature-it/ngx-generic/models";
import {EntityTypeData} from "./entity-type-data";

export class EntityTypeTree extends AbstractDTO{
    head: string;
    entity_type: EntityTypeData;
    entity_type_of: EntityTypeData;
    show_related_node: boolean;
    show_inline: boolean;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};
        this.entity_type = EntityTypeData.create({
            name: attributes['name'],
            entity_type_var: attributes['entity_type_var'],
            is_tree: attributes['is_tree'],
        });
        this.entity_type_of = EntityTypeData.create({
            name: attributes['related_name'],
            entity_type_var: attributes['related_entity_type_var'],
        });
        this.head = attributes['head'] || '';
        this.show_related_node = !!Number(attributes['show_related_node']) ;
        this.show_inline = !!Number(attributes['show_inline']);
    }

    public getRelatedEntityTypeVar() {
        return this.entity_type_of.entity_type_var;
    }
}
